import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const YUZU_APY_URL = 'https://defi-api.yuzu.money/proxy/apy'
const syzUSD = 'Staked Yuzu USD::syzUSD'

export const syzusdFetcher: YieldFetcher = {
  label: 'SYZUSD',
  fetch: async () => {
    const res = await fetch(YUZU_APY_URL).then((r) => r.json())
    return { [syzUSD]: apyToAprPercent(res?.data?.syzusd_apy ?? 0) }
  },
}
